<span class="history-icon" title="{{displayNameKey | translate}} {{'Common.SearchColumnsAndDetailsFields.History' | translate}}">
    <i class="fa fa-history" aria-hidden="true"></i>
</span>